import 'slick-carousel/slick/slick.scss';
import 'slick-carousel/slick/slick-theme.scss';

export { default as Slider } from './Slider';
export { SliderButton } from './SliderButton';
export { SliderControl } from './SliderControl';

export * from './utils';
